var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.125 12.375H85.25V15.125H81.125V12.375Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.125 72.875H85.25V75.625H81.125V72.875Z",
    fill: "#B8B8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.25 79.75H77V85.25H74.25V79.75Z",
    fill: "#B8B8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 79.75H13.75V85.25H11V79.75Z",
    fill: "#B8B8B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 35.75H23.375V38.5H24.75C25.5076 38.5 26.125 37.884 26.125 37.125C26.125 36.366 25.5076 35.75 24.75 35.75Z",
    fill: "#B8B8B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 35.75H33V38.5H34.375C35.1326 38.5 35.75 37.884 35.75 37.125C35.75 36.366 35.1326 35.75 34.375 35.75Z",
    fill: "#B8B8B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 41.25H23.375V44H24.75C25.5076 44 26.125 43.384 26.125 42.625C26.125 41.866 25.5076 41.25 24.75 41.25Z",
    fill: "#B8B8B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35.75C43.2424 35.75 42.625 36.366 42.625 37.125V39.875H45.375V37.125C45.375 36.366 44.7576 35.75 44 35.75Z",
    fill: "#B8B8B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 71.5H15.125V77H9.625V71.5Z",
    fill: "#B8B8B8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0559 61.8752C42.4588 61.8752 42.8479 61.7954 43.2137 61.6579L36.373 54.8173L38.3104 67.4137C41.8318 67.646 45.1992 68.9138 48.0055 71.0505L54.5505 64.5055C52.4138 61.6992 51.146 58.3332 50.9137 54.8118L38.3159 52.873L45.1579 59.715C45.294 59.3479 45.3752 58.9602 45.3752 58.5573V57.7515H48.1252V58.5573C48.1252 60.1784 47.494 61.7019 46.3487 62.8487C45.2033 63.9954 43.6784 64.6265 42.0559 64.6265H41.2502V61.8765L42.0559 61.8752Z",
    fill: "#B8B8B8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6816 74.248L57.736 65.1937L62.6657 70.1233L53.6113 79.1777L48.6816 74.248Z",
    fill: "#B8B8B8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 11H15.125V16.5H9.625V11Z",
    fill: "#B8B8B8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.25 19.25H71.5C70.741 19.25 70.125 18.6354 70.125 17.875V15.125H17.875V17.875C17.875 18.6354 17.259 19.25 16.5 19.25H13.75V68.75H16.5C17.259 68.75 17.875 69.3646 17.875 70.125V72.875H45.8329C43.2891 71.0985 40.2586 70.125 37.125 70.125C36.4457 70.125 35.8696 69.63 35.7665 68.959L33.0165 51.084C32.9505 50.6509 33.0935 50.2122 33.4029 49.9029C33.7136 49.5921 34.155 49.4519 34.584 49.5165L52.459 52.2665C53.13 52.3696 53.625 52.9471 53.625 53.625C53.625 56.8425 54.6439 59.9569 56.5139 62.5419L56.7779 62.2779C57.3155 61.7402 58.1845 61.7402 58.7221 62.2779L65.5971 69.1529C66.1348 69.6905 66.1348 70.5595 65.5971 71.0971L63.8193 72.875H70.125V70.125C70.125 69.3646 70.741 68.75 71.5 68.75H74.25V19.25ZM28.875 42.625C28.875 44.8993 27.0243 46.75 24.75 46.75H22C21.241 46.75 20.625 46.1354 20.625 45.375V34.375C20.625 33.6146 21.241 33 22 33H24.75C27.0243 33 28.875 34.8507 28.875 37.125C28.875 38.181 28.4762 39.1449 27.8217 39.875C28.4762 40.6051 28.875 41.569 28.875 42.625ZM38.5 46.5135V46.75H35.75V46.5135C35.75 44.5555 35.0446 42.7089 33.7686 41.25H33V46.75H30.25V34.375C30.25 33.6146 30.866 33 31.625 33H34.375C36.6493 33 38.5 34.8507 38.5 37.125C38.5 38.5413 37.7822 39.7925 36.6905 40.535C37.8675 42.2895 38.5 44.352 38.5 46.5135ZM48.125 46.75H45.375V42.625H42.625V46.75H39.875V37.125C39.875 34.8507 41.7257 33 44 33C46.2743 33 48.125 34.8507 48.125 37.125V46.75ZM57.75 45.375C57.75 46.013 57.3114 46.5657 56.6912 46.7142C56.5854 46.739 56.4795 46.75 56.375 46.75C55.8621 46.75 55.3822 46.464 55.1444 45.9896L52.25 40.1995V46.75H49.5V34.375C49.5 33.737 49.9386 33.1842 50.5588 33.0357C51.1871 32.8927 51.8196 33.1884 52.1056 33.759L55 39.5491V32.9986H57.75V45.375ZM67.375 42.625C67.375 44.8993 65.5243 46.75 63.25 46.75H60.5C59.741 46.75 59.125 46.1354 59.125 45.375V34.375C59.125 33.6146 59.741 33 60.5 33H63.25C65.5243 33 67.375 34.8507 67.375 37.125V42.625Z",
    fill: "#B8B8B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.875 71.5H78.375V77H72.875V71.5Z",
    fill: "#B8B8B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 35.75H61.875V44H63.25C64.0076 44 64.625 43.384 64.625 42.625V37.125C64.625 36.366 64.0076 35.75 63.25 35.75Z",
    fill: "#B8B8B8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.875 11H78.375V16.5H72.875V11Z",
    fill: "#B8B8B8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.75H13.75V8.25H11V2.75Z",
    fill: "#B8B8B8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12.375H6.875V15.125H2.75V12.375Z",
    fill: "#B8B8B8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.25 2.75H77V8.25H74.25V2.75Z",
    fill: "#B8B8B8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 72.875H6.875V75.625H2.75V72.875Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.821cbad22b198a363cf165a1a9210e48.svg";
export { ForwardRef as ReactComponent };